import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DATEX_APP_API_URL } from './application.service';
import { ESideKickRequestStatus } from './sidekick.do';

@Injectable({
  providedIn: 'root'
})
export class SideKickService {
  protected get endpointUrl(): string {
    return `${this.apiUrl}sidekick`
  }

  constructor(
    private http: HttpClient,
    @Inject(DATEX_APP_API_URL) private apiUrl: string) {
  }

  public getSuggestedCommitDescription(applicationId: number): Promise<{ suggestionId: number, title: string, description: string, requestStatusId: ESideKickRequestStatus }> {
    const url = `${this.endpointUrl}/${applicationId}/suggestCommit`;
    return firstValueFrom(this.http.get<{ suggestionId: number, title: string, description: string, requestStatusId: ESideKickRequestStatus }>(url));
  }

  public suggestCommitDescription(applicationId: number): Promise<number> {
    const url = `${this.endpointUrl}/${applicationId}/suggestCommit`;
    return firstValueFrom(this.http.post<number>(url, null));
  }

  public getCodeReview(applicationId: number): Promise<{ suggestionId: number, codeReviewMarkdown: string, requestStatusId: ESideKickRequestStatus }> {
    const url = `${this.endpointUrl}/${applicationId}/codeReview`;
    return firstValueFrom(this.http.get<{ suggestionId: number, codeReviewMarkdown: string, requestStatusId: ESideKickRequestStatus }>(url));
  }

  public codeReview(applicationId: number): Promise<number> {
    const url = `${this.endpointUrl}/${applicationId}/codeReview`;
    return firstValueFrom(this.http.post<number>(url, null));
  }

  public getReleaseNotes(fromVersionId: number, toVersionId: number): Promise<{ suggestionId: number, technicalNotes: string, customerNotes: string, requestStatusId: ESideKickRequestStatus }> {
    const url = `${this.endpointUrl}/releaseNotes/${fromVersionId}/${toVersionId}`;
    return firstValueFrom(this.http.get<{ suggestionId: number, technicalNotes: string, customerNotes: string, requestStatusId: ESideKickRequestStatus }>(url));
  }

  public generateReleaseNotes(fromVersionId: number, toVersionId: number): Promise<number> {
    const url = `${this.endpointUrl}/releaseNotes/${fromVersionId}/${toVersionId}`;
    return firstValueFrom(this.http.post<number>(url, null));
  }

  stopSideKickSuggestion(suggestionId: number): Promise<void> {
    const url = `${this.endpointUrl}/${suggestionId}/stop`;
    return firstValueFrom(this.http.post<void>(url, null));
  }
}
